/** @jsxImportSource @emotion/react */

import { memo } from "react";
import { useHistory } from "react-router-dom";

import { PaginationProps, Pagination as PaginationComp } from "@material-ui/lab";

import { Align, container } from "./styles";

export interface Props extends PaginationProps {
  page?: number;
  perPage?: number;
  total?: number;
  align?: Align;
  marginTop?: number;
  to?: string;
}

const Pagination = ({
  page = 1,
  perPage,
  total,
  count,
  align = "center",
  marginTop = 3,
  to,
  onChange,
  ...rest
}: Props): JSX.Element | null => {
  const { push } = useHistory();

  if (count !== undefined && count <= 1) return null;

  const calculatedCount = total && perPage && Math.ceil(total / perPage);
  if (!calculatedCount || calculatedCount === 1) return null;

  return (
    <div css={container(align, marginTop)}>
      <PaginationComp
        page={page}
        count={count || calculatedCount}
        onChange={(e, p): void => {
          if (to) push(to.replace("$(p)", p.toString()));
          if (onChange) onChange(e, p);
        }}
        color="primary"
        shape="rounded"
        {...rest}
      />
    </div>
  );
};

export default memo(Pagination);
